import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToggleSlideComponent } from './toggle-slide/toggle-slide.component';
import { NotificationBarComponent } from './notification-bar/notification-bar.component';
import { SharedModule } from '../shared/shared.module';
import { LoadingAnimationComponent } from './loading-animation/loading-animation.component';
import { PaginatorModule } from './paginator/paginator.module';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { ScaffoldDialogComponent } from './scaffold-dialog/scaffold-dialog.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';
import { NotificationMessageComponent } from './notification-sidebar/notification-message/notification-message.component';
import { RouterModule } from '@angular/router';
import { ScaffoldTypeComponent } from './scaffold-type/scaffold-type.component';
import { IntegrationBannerComponent } from './integration-banner/integration-banner.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { LayoutHeaderComponent } from './layout/layout-header/layout-header.component';
import { LayoutSidebarComponent } from './layout/layout-sidebar/layout-sidebar.component';
import { LayoutColumnComponent } from './layout/layout-column/layout-column.component';
import { PrimengModule } from '@app/shared/primeng.module';
import { ScaffoldToastComponent } from './notifcation/scaffold-toast/scaffold-toast.component';
import { SidebarNavComponent } from './sidebar-nav/sidebar-nav.component';
import { VerifyPasswordComponent } from './verify-password/verify-password.component';
import { GenericModule } from '@app/generic/generic.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PrimengModule,
    RouterModule,
    ScaffoldDialogComponent,
    GenericModule,
    PaginatorModule,
  ],
  exports: [
    ToggleSlideComponent,
    NotificationBarComponent,
    LoadingAnimationComponent,
    PaginatorModule,
    SearchBarComponent,
    ScaffoldDialogComponent,
    ScaffoldTypeComponent,
    VerifyPasswordComponent,
    IntegrationBannerComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    LayoutColumnComponent,
    ScaffoldToastComponent,
    SidebarNavComponent,
  ],
  declarations: [
    ToggleSlideComponent,
    NotificationBarComponent,
    LoadingAnimationComponent,
    SearchBarComponent,
    NotificationSidebarComponent,
    NotificationMessageComponent,
    ScaffoldTypeComponent,
    VerifyPasswordComponent,
    IntegrationBannerComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    LayoutColumnComponent,
    ScaffoldToastComponent,
    SidebarNavComponent,
  ],
})
export class FrameworkModule {}
